export default __webpack_public_path__ + "static/media/Golden Visa - Overview.a91aefa0.jpg";